import React from 'react';

import { Broom, SmartHome, Wifi } from '@r1-frontend/ui-react/components/svg/main';
import { TicketDiscount } from '@r1-frontend/ui-react/components/svg/money';
import { TwentyFourSupport } from '@r1-frontend/ui-react/components/svg/support';
import { VideoPlay } from '@r1-frontend/ui-react/components/svg/video';

export const PromoInfoData = [
    {
        icon: <Broom size={32} />,
        title: 'Подключение без вреда ремонту',
        description: 'Проложим интернет-кабель и&nbsp;не&nbsp;повредим стены. Лишние провода спрячем за&nbsp;плинтус.',
    },
    {
        icon: <SmartHome size={32} />,
        title: 'Тариф-конструктор',
            description: 'Соберите его сами онлайн. Чем больше услуг добавите в&nbsp;тариф, тем выгоднее он&nbsp;будет.',
    },
    {
        icon: <Wifi size={32}/>,
        title: 'Бесплатный городской Wi-Fi',
            description: 'Оставайтесь на&nbsp;связи в&nbsp;кафе, парках и&nbsp;торговых центрах.',
    },
    {
        icon: <TicketDiscount size={32} />,
        title: 'Бонусы и новые предложения',
            description: 'Всё самое интересное про тарифы, оплату бонусами, ТВ-приставки, роутеры и&nbsp;другие услуги.',
    },
    {
        icon: <TwentyFourSupport size={32} />,
        title: 'Техподдержка',
            description: 'Ответим на&nbsp;все вопросы и&nbsp;решим любые затруднения в&nbsp;чате или по&nbsp;телефону.',
    },
    {
        icon: <VideoPlay size={32} />,
        title: 'Видеосервис Movix',
            description: 'В&nbsp;приложении Movix 170+&nbsp;ТВ-каналов и&nbsp;100&nbsp;000 фильмов и&nbsp;сериалов из&nbsp;онлайн-кинотеатров.',
    },
];
